import { render, staticRenderFns } from "./cancelorderDia.vue?vue&type=template&id=4428252c&scoped=true"
import script from "./cancelorderDia.vue?vue&type=script&lang=js"
export * from "./cancelorderDia.vue?vue&type=script&lang=js"
import style0 from "./cancelorderDia.vue?vue&type=style&index=0&id=4428252c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4428252c",
  null
  
)

export default component.exports